import { useEffect } from 'react';
import extensionImage from '../../assets/extension.jpeg';
import { PuzzleSvg, DownArrowSvg } from '../../components/Icons/svgIcons';
import Image from '../../components/Image/Image';
import deviceService from '../../services/device/deviceService';

const IconAA = () => {
    return (
        <span>
            <b className="text-sm">A</b><b className="text-lg">A</b>
        </span>
    )
}

const Intro = ({id}) => {
    const onDeviceUnselectedHandler = async () => {
        if (id) {
            await deviceService.disconnect(id);
        }
        window.location.reload();
    }

    useEffect(() => {
        return () => {
            onDeviceUnselectedHandler();
        }
    }, []);

    return (
        <div className='w-full h-full flex flex-col items-start p-4'>
            <h3 className="text-2xl font-medium text-gray-600">Enable SafariBLE extension</h3>
            <div className="h-48 flex items-center">
                <Image imageSrc={extensionImage} imageAlt="SafariBLE extension" />
            </div>
            <div className="grow-1 h-full flex flex-col justify-center">
            <ul className="flex flex-col items-start gap-2 text-lg font-medium text-gray-600">
                <li>1. Tap <IconAA/></li>
                <li>2. Tap <b>Manage Extension</b> <PuzzleSvg /></li>
                <li>3. Enable <b>SafariBLE</b></li>
                <li>4. Reload the page</li>
            </ul>
            </div>
            <div className="h-48 flex items-center relative">
                <DownArrowSvg className="animate-bounce w-8 h-12 absolute top-10"/> 
                <span className="font-medium text-blue-500 ml-8">
                    Tap <IconAA/> and go to <PuzzleSvg color="rgb(59 130 246)" className="ml-1"/>
                </span>
            </div>
        </div>
    )
}

export default Intro;